import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { FullPageMessage } from "@/auth/FullPageMessage";
import { useAuth } from "@/auth/useAuth";

export default function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") return <FullPageMessage spinner title="Checking your session…" />;
  if (status === "signedOut") {
    // The public landing page is mdf.lu; the app only knows its login page.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
